import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import isoWeek from "dayjs/plugin/isoWeek";
import { OPEN_NOW_CATEGORY } from "./openNowConst";
dayjs.extend(isBetween);
dayjs.extend(isoWeek);
const getSelectedFilterKeys = (selectedFilters) => Object.entries(selectedFilters)
    .filter(([, { selected }]) => selected)
    .map(([, { category, key }]) => ({ category, key }));
const getCurrentDayWithTime = (time) => {
    const today = dayjs();
    const hm = time.split(":");
    const h = parseInt(hm[0]);
    const m = parseInt(hm[1]);
    const dateWithTime = today.hour(h).minute(m).second(0);
    return dateWithTime;
};
const checkIfStoreIsOpen = (store) => {
    if (!store.opening_hours)
        return false;
    const now = dayjs();
    const currentStoreDay = store.opening_hours[0]?.days[now.isoWeekday() - 1];
    if (!currentStoreDay)
        return false;
    const { open_time, close_time, break_end_time, break_start_time } = currentStoreDay;
    const openTIme = getCurrentDayWithTime(open_time);
    const closeTIme = getCurrentDayWithTime(close_time);
    if (!break_end_time) {
        return now.isBetween(openTIme, closeTIme);
    }
    const breakStartTime = getCurrentDayWithTime(break_start_time);
    const breakEndTime = getCurrentDayWithTime(break_end_time);
    return now.isBetween(openTIme, breakStartTime) || now.isBetween(breakEndTime, closeTIme);
};
const checkStoreProductAttributes = (store, key, category) => {
    if (!store.product_attributes)
        return false;
    const storeProductAttributes = store?.product_attributes;
    const storeProductAttributesVending = store?.product_attributes_vending_machine;
    const storeCategory = storeProductAttributes?.find((attribute) => attribute.key === category);
    const storeCategoryVending = storeProductAttributesVending?.find((attribute) => attribute.key === category);
    return (storeCategory?.values.some((v) => v.value === key) ??
        storeCategoryVending?.values.some((v) => v.value === key) ??
        false);
};
const checkStoreBySelectedFilters = (store, selectedFilters) => {
    const selectedFiltersKeys = getSelectedFilterKeys(selectedFilters);
    if (selectedFiltersKeys.length === 0) {
        return true;
    }
    return selectedFiltersKeys.every(({ key, category }) => {
        if (category === OPEN_NOW_CATEGORY) {
            return checkIfStoreIsOpen(store);
        }
        if (category === "ProductColors" || category === "ProductFlavours") {
            return checkStoreProductAttributes(store, key, category);
        }
        if (category === "storetype") {
            return store.storetype === key;
        }
        if (["product_types", "product_types_vending_machine"].includes(category)) {
            const productTypes = store.product_types;
            const productTypesVendingMachine = store?.product_types_vending_machine;
            return (productTypes?.some((filter) => filter.key === key && filter.is_available === "true") ||
                productTypesVendingMachine?.some((filter) => filter.key === key && filter.is_available === "true"));
        }
        if (category === "services") {
            const storeServices = store.services;
            return storeServices?.some((filter) => filter.key === key && filter.is_available === "true");
        }
        return false;
    });
};
export const getStoresFilteredBySelectedFilters = (stores, selectedFilters) => stores.filter((store) => checkStoreBySelectedFilters(store, selectedFilters));
//# sourceMappingURL=getStoresFilteredBySelectedFilters.js.map